import React from 'react';
import { useBarcode } from 'next-barcode';

const BarcodeLinear = (props) => {

    const { inputRef } = useBarcode({
        value: props.barcode,
        options: {
            text: props.barcodeLabel,
            format: "CODE128",
            margin: 0,
            height: props.barcodeHeight
        }
    });

    return (
        <div>
            <svg ref={inputRef} />
        </div>
    );
};

export default BarcodeLinear;
